import React, { useMemo } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { generateMonthOptions, validateMonthRange } from "./revenueSummaryUtils";

const MonthSelect = ({ value, onChange, placeholder, minWidth = "168px" }) => {
	const monthOptions = generateMonthOptions(3);

	const renderValue = (selected) => {
		if (!selected) return placeholder;
		const option = monthOptions.find((o) => o.value === selected);
		return option?.label || selected;
	};

	return (
		<FormControl size="small" style={{ minWidth }}>
			<Select
				value={value}
				onChange={(e) => onChange(e.target.value)}
				displayEmpty
				renderValue={renderValue}
				style={{
					background: "var(--bg-card)",
					borderRadius: "var(--radius-md)",
					fontWeight: "600",
				}}
			>
				<MenuItem value="">
					<em>{placeholder}</em>
				</MenuItem>
				{monthOptions.map((option) => (
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

const RevenuePeriodSelector = ({
	viewMode,
	setViewMode,
	selectedMonth,
	setSelectedMonth,
	startMonth,
	setStartMonth,
	endMonth,
	setEndMonth,
}) => {
	const rangeValidation = useMemo(
		() => validateMonthRange(startMonth, endMonth),
		[startMonth, endMonth],
	);

	return (
		<div className="rs-period-selector">
			<div className="rs-period-mode-toggle" role="group" aria-label="Period type">
				<button
					type="button"
					className={`rs-period-mode-btn${viewMode === "single" ? " rs-period-mode-btn--active" : ""}`}
					onClick={() => setViewMode("single")}
				>
					Month
				</button>
				<button
					type="button"
					className={`rs-period-mode-btn${viewMode === "range" ? " rs-period-mode-btn--active" : ""}`}
					onClick={() => setViewMode("range")}
				>
					Range
				</button>
			</div>

			{viewMode === "single" ? (
				<MonthSelect
					value={selectedMonth}
					onChange={setSelectedMonth}
					placeholder="Select month"
					minWidth="200px"
				/>
			) : (
				<div className="rs-period-range-fields">
					<MonthSelect
						value={startMonth}
						onChange={setStartMonth}
						placeholder="Start month"
					/>
					<span className="rs-period-separator">to</span>
					<MonthSelect
						value={endMonth}
						onChange={setEndMonth}
						placeholder="End month"
					/>
					{startMonth && endMonth && !rangeValidation.valid && (
						<span className="rs-period-error">{rangeValidation.error}</span>
					)}
				</div>
			)}
		</div>
	);
};

export default RevenuePeriodSelector;
